/**
@format
@flow
*/

import type { PatchOpType } from '@ziynx/flow-types/globals';

type CroppedAreaPixels = {
  x: number,
  y: number,
  width: number,
  height: number,
};

type TransformedCropDimensions = {
  top: number,
  left: number,
  width: number,
  height: number,
};

/**
 * Helper to transform crop dimensions to send when presign media url
 */
const transformCropDimensions = (
  croppedAreaPixels: CroppedAreaPixels,
): TransformedCropDimensions => {
  const {
    x, y, width, height,
  } = croppedAreaPixels || {};

  return {
    top: y,
    left: x,
    width,
    height,
  };
};

const getPatchCropDimensions = (
  croppedAreaPixels: CroppedAreaPixels,
): Array<PatchOpType> => {
  const {
    x, y, width, height,
  } = croppedAreaPixels || {};

  return [
    {
      op: 'replace',
      path: 'cropDimensions.top',
      value: y,
    },
    {
      op: 'replace',
      path: 'cropDimensions.left',
      value: x,
    },
    {
      op: 'replace',
      path: 'cropDimensions.width',
      value: width,
    },
    {
      op: 'replace',
      path: 'cropDimensions.height',
      value: height,
    },
  ];
};

export { getPatchCropDimensions, transformCropDimensions };
